import React from 'react';
import styled from 'styled-components';
import FormattedAmount from '../FormattedAmount';

const CurrentBidWrapper = styled.div`
  background-color: #3994de;
  color: #fff;
  border-radius: 3px;
  padding: 2px 8px;
  display: inline-flex;

  @media (max-width: 600px) { 
    padding: 2px;
  }
`;

type Props = {
  amount: number;
};

export const CurrentBidComponent = ({ amount }: Props) => (
  <CurrentBidWrapper>
    <FormattedAmount amount={amount} />
  </CurrentBidWrapper>
);
